import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Product from '../Product/Product';
import './ProductDetail.css';
const ProductDetail = () => {
    const {productKey} = useParams();
    const [product, setProduct] = useState({});

    useEffect(() => {
        fetch("https://hidden-dusk-07005.herokuapp.com/product/"+ productKey)
        .then(res => res.json())
        .then(data => {
            setProduct(data);
            console.log(data);
        })
    }, [productKey])

    return (
        <div>
            <h1>{productKey} Product Detail</h1>
            <Product showAddToCart={false} product={product}></Product>
        </div>
    );
};

export default ProductDetail;